import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, FormControlLabel, FormLabel, RadioGroup, Radio, Paper } from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import { alert } from "src/services/alert";
import { COMP_NAME, PAGE_TYPES } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import NavBack from "src/components/common/NavBack";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { Switch } from "@mui/material";
import DiyHot from "./components/DiyHot";


const COMPONENTS = [
  {name: 'DiyHot', label: '热门'},
];

export default function DiyDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const item = useLocation().state || {};

  const [component, setComponent] = useState("");
  const [components, setComponents] = useState(JSON.parse(item.data) || []);

  const [editIdx, setEditIdx] = useState(-1);
  const [editComponent, setEditComponent] = useState({});

  const [form, setForm] = useState({
    name: item.name || "",
    type: item.type || 0,
    data: item.data || "",
    isDefault: item.isDefault != undefined ? item.isDefault : false,
  });


  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleAddComponent() {

    const comp = COMPONENTS.find(c => c.name === component);
    const obj = { ...comp };
    // switch (type) {
    //   case "radio":
    //   case "checkbox":
    //     obj.options = [{ text: "选项" }, { text: "选项" }];
    //     break;
    // }

    setComponents([...components, obj]);
  }

  function handleComponentChange(data) {
    components[editIdx].data = data;
    setComponents([...components]);

    setEditComponent(null);
  }

  function renderFormItems() {
    return components.map((comp, i) => {
      const { name, label } = comp;


      return (
        <Stack position="relative" variant="outlined" sx={{ py: 1, px: 1, mb: 1, borderBottom: '1px solid rgba(145, 158, 171, 0.24)' }} key={i}>
          <Typography fontSize={12}>{label}</Typography>

          <Stack direction="row" position="absolute" top="0" right="0">
            <Button onClick={() => {
              // setEditIdx(i);
              // setQForm({
              //   ...deepClone(q)
              // })；

              setEditIdx(i);
              setEditComponent(comp)
            }}>编辑</Button>
            <Button onClick={() => {
              setComponents(components.filter((_, idx) => idx !== i));
            }}>删除</Button>
          </Stack>
        </Stack>
      );
    });
  }

  function handleSubmit() {
    const formData = {
      ...form,
      data: JSON.stringify(components),
    };

    if (id) {
      formData.id = id;
    }

    axios
      .post(id ? "/diy/edit" : "/diy/add", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          navigate(-1, { replace: true });
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加页面出错: ", err);
      });
  }


  return (
    <Page title={`${id ? "编辑" : "添加"}页面 | ${COMP_NAME}`}>
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title={`${id ? "编辑" : "添加"}页面`} />
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          <FormItem title="名称" required>
            <TextField fullWidth placeholder="请输入名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
          </FormItem>

          <FormItem title="页面类型" required>
            <Select value={form.type} onChange={e => handleIptChange('type', e.target.value)}>
              {PAGE_TYPES.map((t, i) => (
                <MenuItem key={t} value={i}>{t}</MenuItem>
              ))}
            </Select>
          </FormItem>

          {/* <FormItem title="封面">
            <Uploader images={form.cover} onUploaded={(v) => handleIptChange("cover", v)} />
          </FormItem> */}

          <FormItem title="是否默认" required>
            <Switch checked={form.isDefault} onChange={e => handleIptChange('isDefault', e.target.checked)} />
          </FormItem>

          <FormItem title="界面" required>
            <Paper variant="outlined" sx={{ py: 1, px: 1, width: '100%' }}>
              {renderFormItems()}

              <Stack direction="row">
                <Select value={component} onChange={(e) => setComponent(e.target.value)}>
                  {COMPONENTS.map(comp => (
                    <MenuItem value={comp.name}>{comp.label}</MenuItem>
                  ))}
                </Select>
                <Button onClick={handleAddComponent}>添加组件</Button>
              </Stack>
            </Paper>
          </FormItem>

          <FormItem>
            <Button variant="contained" type="submit" onClick={handleSubmit}>
              确认{id ? "保存" : "添加"}
            </Button>
          </FormItem>
        </Paper>
      </Container>

      {!!editComponent && editComponent.name === 'DiyHot' && (
        <DiyHot data={editComponent.data} open={true} onClose={() => setEditComponent('')} onChange={handleComponentChange} />
      )}
    </Page>
  );
}
